import styled from 'styled-components';

export const UploadEvidenceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const UploadMessage = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N600};
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  padding-left: 18px;
  cursor: pointer;
`;
